import { useMutation } from '@apollo/client';
import ConfirmDialog from '@website/components/utilities/ConfirmDialog';
import { RemoveWaypointDocument } from '@website/types/graphqlOperations';
import { useState } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { MdDelete } from 'react-icons/md';

type Props = {
  wayPointID: string;
};

export function DeleteWayPoint({ wayPointID }: Props) {
  const [isConfirmDialogueVisible, setIsConfirmDialogueVisible] =
    useState(false);

  const [removeWaypoint, { loading }] = useMutation(RemoveWaypointDocument, {
    update(cache, { data }) {
      // remove the waypoint from the cache, so it doesn't show up in the
      const id = cache.identify({
        __typename: 'WayPoint',
        id: data.removeWayPoint.id,
      });
      cache.evict({ id });
    },
  });

  const onRemoveWaypoint = async () => {
    try {
      await removeWaypoint({
        variables: {
          id: wayPointID,
        },
      });
    } catch (e) {
      if (e.networkError) {
        alert(
          'Internet connection lost - please retry when you are connected.',
        );
      } else {
        alert(e);
      }
    }
  };

  return (
    <>
      <ConfirmDialog
        setVisible={(visible) => setIsConfirmDialogueVisible(visible)}
        title="Deleting meet point"
        body={`Are you sure you want to delete the meeting point?`}
        visible={isConfirmDialogueVisible}
        onCancelFn={() => setIsConfirmDialogueVisible(false)}
        onConfirmFn={() => onRemoveWaypoint()}
      />

      <Button
        aria-label="Delete"
        variant="danger"
        className="float-end mb-2 p-0 px-2 pb-1"
        onClick={() => setIsConfirmDialogueVisible(true)}
      >
        {loading ? (
          <>
            <Spinner size="sm" animation="border" className="m-1" />
          </>
        ) : (
          <>
            <MdDelete /> Delete
          </>
        )}
      </Button>
    </>
  );
}
